import { render } from "./StudentPracticumAttendanceDataTable.vue?vue&type=template&id=377b2a8c&scoped=true"
import script from "./StudentPracticumAttendanceDataTable.vue?vue&type=script&lang=js"
export * from "./StudentPracticumAttendanceDataTable.vue?vue&type=script&lang=js"

import "./StudentPracticumAttendanceDataTable.vue?vue&type=style&index=0&id=377b2a8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377b2a8c"]])

export default __exports__